// Module
var code = "<div class=\"full-height\" ui-view flex layout=\"column\"></div> ";
// Exports
module.exports = code;